import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import ErrorAlert from "../admin/components/ErrorAlert";
import SingleCityHotelsCard from "../components/SingleCityHotelsCard";
import NothingToShow from "../components/NothingToShow";

export default function AllPlaces() {
  // State Handling
  const [error, setError] = useState("");
  const [fetchedHotels, setFetchedHotels] = useState([]);
  const [fetchedPlaces, setFetchedPlaces] = useState([]);
  const [loading, setLoading] = useState(true);

  // --------- Reading/Fetching Hotels From Database ---------
  const readingHotels = async () => {
    const response = await fetch(
      "https://hotelbnb-backend.onrender.com/read-hotels"
    );
    const result = await response.json();

    if (!response.ok) {
      setError("Sorry, Something went wrong");
    } else if (response.ok) {
      setError("");
      setFetchedHotels(result);
    }
  };

  // --------- Reading/Fetching Places From Database ---------
  const readingPlaces = async () => {
    try {
      const response = await fetch(
        "https://hotelbnb-backend.onrender.com/read-places"
      );
      const result = await response.json();

      if (!response.ok) {
        setError("Sorry, Something went wrong");
      } else if (response.ok) {
        setFetchedPlaces(result);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    readingHotels();
    readingPlaces();
  }, []);

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Fetching Places</p>
      </div>
    );

  if (!loading)
    return (
      <>
        <div className="container-fluid p-0 hero-section hero-section-spacing all-places-cards">
          {/* Heading Start */}
          <div className="row app-container">
            <h2 className="search-for-room-heading search-hotel-bookNow-heading p-0">
              All Places
            </h2>
          </div>
          {/* Heading End */}

          {/* Cards Start */}
          <div className="row cards-container">
            <div className="col-12 d-flex flex-wrap p-0 interesting-places-cards justify-content-center justify-content-lg-start">
              {/* Showing Alert based on http request response if places can't be fetched Start */}
              {error && <ErrorAlert errorMsg={error} />}
              {/* Showing Alert based on http request response if places can't be fetched End */}

              {!fetchedPlaces.length ? <NothingToShow /> : ""}

              {fetchedPlaces?.slice(0, 4).map((singlePlace) => {
                return (
                  <SingleCityHotelsCard
                    key={singlePlace._id}
                    img={singlePlace.place_img}
                    title={singlePlace.place_city}
                    mb="4"
                    totalNoOfHotels={fetchedHotels?.filter((singleHotel) => {
                      return singleHotel.hotel_city == singlePlace.place_city;
                    })}
                  />
                );
              })}
            </div>
          </div>
          {/* Cards End */}
        </div>

        {/* Footer Start */}
        <Footer />
        {/* Footer End */}
      </>
    );
}
